import template from './tableGridValidationCell.html';
import controller from './tableGridValidationCell.controller';
import _ from 'lodash';

let tableGridValidationCellComponent = () => {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      columns: '='
    },
    template,
    controller,
    controllerAs: 'vm',
    link: (scope, elem, attrs, ctrl) => {
      scope.column = _.find(scope.columns, {
        name: scope.columnName
      });

      scope.vm = scope;
      scope.vm.cellValue = scope.row[scope.column.name];
      scope.vm.validationValue = ctrl.getValidationValue(scope.row, scope.column.validation);
      scope.vm.validationClass = ctrl.getValidationClass(scope.column.validation);
    }
  };
};

export
default tableGridValidationCellComponent;


// WEBPACK FOOTER //
// ./app/components/tableGridValidationCell/tableGridValidationCell.component.js